import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import DestinationsActions from '../Redux/DestinationRedux'
import { getToken } from '../Services/GetToken'

export function * getDestination (api, action) {
  // make the call to the api
  const response = yield call(api.getDestination)
  try {
    if (response.ok) {
      yield put(DestinationsActions.destinationSuccess(response.data.data))
    } else {
      yield put(DestinationsActions.destinationFailure(response.data.message))
    }
  } catch (e) {
    yield put(DestinationsActions.destinationFailure(e))
  }
}

export function * createDestination (api, action) {
  // make the call to the api

  yield baseFetchToken(api.createDestination,
    action.data,
    getToken,
    DestinationsActions.destinationCreateSuccess,
    DestinationsActions.destinationCreateFailure)
}

export function * deleteDestination (api, action) {
  // make the call to the api
  yield baseFetchToken(api.deleteDestination,
    action.data,
    getToken,
    DestinationsActions.destinationDeleteSuccess,
    DestinationsActions.destinationDeleteFailure)
}

export function * updateDestination (api, action) {
  // make the call to the api
  yield baseFetchToken(api.updateDestination,
    action.data,
    getToken,
    DestinationsActions.destinationUpdateSuccess,
    DestinationsActions.destinationUpdateFailure)
}

export function * addAttractionToDestination (api, action) {
  // make the call to the api
  yield baseFetchToken(api.addAttractionToDestination,
    action.data,
    getToken,
    DestinationsActions.addAttractionToDestinationSuccess,
    DestinationsActions.addAttractionToDestinationFailure)
}

export function * deleteAttractionFromDestination (api, action) {
  // make the call to the api
  yield baseFetchToken(api.deleteAttractionFromDestination,
    action.data,
    getToken,
    DestinationsActions.deleteAttractionFromDestinationSuccess,
    DestinationsActions.deleteAttractionFromDestinationFailure)
}

export function * addPlaceToDestination (api, action) {
  // make the call to the api
  yield baseFetchToken(api.addPlaceToDestination,
    action.data,
    getToken,
    DestinationsActions.addPlaceToDestinationSuccess,
    DestinationsActions.addPlaceToDestinationFailure)
}

export function * deletePlaceFromDestination (api, action) {
  // make the call to the api
  yield baseFetchToken(api.deletePlaceFromDestination,
    action.data,
    getToken,
    DestinationsActions.deletePlaceFromDestinationSuccess,
    DestinationsActions.deletePlaceFromDestinationFailure)
}

export function * getContinent (api, action) {
  // make the call to the api
  yield baseFetchToken(api.getContinent,
    action.data,
    getToken,
    DestinationsActions.continentSuccess,
    DestinationsActions.continentFailure)
}



// WEBPACK FOOTER //
// ./src/Sagas/DestinationSagas.js